// import { useLocation } from '@fs/zion-router'

declare type Typename = 'Overlay' | 'Popover' | 'SharedModulesContent' | 'SharedSectionsContent'

export default function useUrlPreviewIdTypename() {
  const urlSearchParams = new URLSearchParams(window.location.search)
  // Sometimes the param is named differently
  let previewId = urlSearchParams.get('previewId') || urlSearchParams.get('_cms.db.previewId') || undefined
  let typename
  if (previewId) {
    typename = (urlSearchParams.get('typename')?.split('_').pop()?.replace('ViewModel', '') as Typename) || undefined
  } else if (window.location.pathname.indexOf('__preview__') !== -1) {
    const previewPathSuffix = window.location.pathname.substring(window.location.pathname.indexOf('__preview__'))
    const pathParts = previewPathSuffix.split('/')

    // pathParts[0]: '__preview__'
    // pathParts[1]: <previewId>
    // pathParts[2]: 'type'
    // pathParts[3]: '<typename>'

    previewId = pathParts[1]
    typename = pathParts[3]
  }

  return { previewId, typename }
}
